// Allowlist de encurtadores que podem ser seguidos (fetch) para achar o link
// final. Fonte unica do bot (url-resolver) e da edge convert-link: so estes
// hosts disparam request, o que fecha SSRF por construcao na edge.

/** Encurtadores proprios de cada loja (fonte unica: allowlist do resolver,
 *  dica de loja no painel e blocklist do encurtador avulso). */
export const STORE_SHORTENER_HOSTS: Readonly<Record<string, readonly string[]>> = {
  amazon: ["amzn.to", "amzn.com", "a.co"],
  shopee: ["s.shopee.com.br", "shope.ee"],
  mercadolivre: ["mercadol.iv", "meli.io", "meli.la"],
  magalu: ["mgl.to", "divulgador.magalu.com", "magalu.onelink.me"],
  aliexpress: ["s.click.aliexpress.com", "a.aliexpress.com"],
  awin: ["tidd.ly"],
  rakuten: ["click.linksynergy.com"],
};

/** Encurtadores genericos: o destino so e conhecido depois de resolver. */
export const GENERIC_SHORTENER_HOSTS: readonly string[] = [
  "bit.ly",
  "tinyurl.com",
  "t.co",
  "ow.ly",
  "buff.ly",
  "goo.gl",
  "rb.gy",
  "cutt.ly",
  "short.io",
  "tiny.cc",
];

export const SHORT_URL_HOSTS: readonly string[] = [
  ...Object.values(STORE_SHORTENER_HOSTS).flat(),
  ...GENERIC_SHORTENER_HOSTS,
];

function hostOf(url: string): string | null {
  try {
    return new URL(url).hostname.toLowerCase().replace(/\.$/, "");
  } catch {
    return null;
  }
}

function hostIn(hostname: string, hosts: readonly string[]): boolean {
  return hosts.some((known) => hostname === known || hostname.endsWith(`.${known}`));
}

/** Loja dona do encurtador da URL (amzn.to -> amazon); null se nao for de loja. */
export function storeOfShortener(url: string): string | null {
  const hostname = hostOf(url);
  if (!hostname) {
    return null;
  }
  const match = Object.entries(STORE_SHORTENER_HOSTS).find(([, hosts]) => hostIn(hostname, hosts));
  return match ? match[0] : null;
}

/** true se o host da URL (ou subdominio) esta na allowlist de encurtadores. */
export function isShortenerUrl(url: string, hosts: readonly string[] = SHORT_URL_HOSTS): boolean {
  const hostname = hostOf(url);
  return hostname !== null && hostIn(hostname, hosts);
}
